import { mapReviews } from './helpers';

const getReviews = state => (state && state.reviews) || {};
const _getAllReviews = state => getReviews(state).allReviews || [];
const _getCurrentReviews = state => getReviews(state).currentReviews || [];
const getReviewById = (state, id) => {
    const currentReview = _getCurrentReviews(state).filter(item => item.id === id);
    return currentReview && currentReview.length ? currentReview[0] : {};
};
const getCurrentPage = state => getReviews(state).currentPage;
const getTotalCount = state => getReviews(state).totalCount;
const getCurrentCount = state => getReviews(state).currentCount;
const getNumberOfItemsPerPage = state => getReviews(state).numberOfItemsPerPage;
const isLoading = state => getReviews(state).loading;
const getActiveFilters = state => getReviews(state).activeFilters || [];
const getActiveSort = state => (getReviews(state).sort || {}).value;
const getProductCode = state => getReviews(state).productCode;
const getAllReviewsLoadedStatus = state => getReviews(state).allReviewsLoaded;
const isAvis = state => getReviews(state).isAvis;
const isPaginated = state => getReviews(state).isPaginated;
const showReactions = state => getReviews(state).showReactions;
const getReportedReviews = state => getReviews(state).reportedReviews;
const getCurrentReview = state => getReviews(state).currentReview || {};
const getTranslationFeatureOn = state => getReviews(state).translationFeatureOn;
const getGoogleApiKey = state => getReviews(state).googleApiKey;
const getLoadReviewsIteration = state => getReviews(state).loadReviewsIteration;

export default {
    getReviews,
    getAllReviews: (state, dateFormat) => mapReviews(_getAllReviews(state), dateFormat),
    getCurrentReviews: (state, dateFormat) => {
        const currentReviews = _getCurrentReviews(state);
        return currentReviews && currentReviews.length
            ? mapReviews(currentReviews, dateFormat)
            : currentReviews;
    },
    getCurrentPage,
    getTotalCount,
    getCurrentCount,
    getNumberOfItemsPerPage,
    isLoading,
    getActiveFilters,
    getActiveSort,
    getProductCode,
    getAllReviewsLoadedStatus,
    isAvis,
    isPaginated,
    showReactions,
    getReportedReviews,
    getReviewById,
    getCurrentReview,
    getTranslationFeatureOn,
    getGoogleApiKey,
    getNeedsTranslation: (state, id) => getReviewById(state, id).needsTranslation || false,
    getShowTranslatedReview: (state, id) => getReviewById(state, id).showTranslatedReview || false,
    getTranslationLoading: (state, id) => getReviewById(state, id).translationLoading || false,
    getLoadReviewsIteration,
};
